import { Component, Input } from '@angular/core';
import { NavController } from 'ionic-angular';
import { CategorieResultPage } from '../../pages/categorie-result/categorie-result';

/**
 * Generated class for the CategoriesCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'categories-card',
  templateUrl: 'categories-card.html'
})
export class CategoriesCardComponent {

  @Input('categorie') categorie: string;

  constructor(private navCtrl:NavController) {
    // console.log('Hello CategoriesCardComponent Component');
  }
  goToCategorieResult(categorie){
    this.navCtrl.push(CategorieResultPage,{categorie:categorie});
  }
}



// WEBPACK FOOTER //
// ./src/components/categories-card/categories-card.ts